import type { HTMLAttributes, ReactNode } from "react";

type SurfaceElement = "article" | "div" | "section";

interface SurfaceProps extends HTMLAttributes<HTMLElement> {
  as?: SurfaceElement;
  children: ReactNode;
  padding?: "none" | "compact" | "default" | "spacious";
  tone?: "default" | "subtle" | "brand";
}

export function Surface({
  as: Component = "section",
  children,
  className = "",
  padding = "default",
  tone = "default",
  ...props
}: SurfaceProps) {
  return (
    <Component
      className={`surface surface--padding-${padding} surface--${tone} ${className}`.trim()}
      {...props}
    >
      {children}
    </Component>
  );
}

export function SectionHeader({
  eyebrow,
  title,
  description,
  action,
  className = "",
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <header className={`section-header ${className}`.trim()}>
      <div>
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      {action && <div className="section-header__action">{action}</div>}
    </header>
  );
}
